<template>
  <v-row v-if="enableConsultaBrinde">
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="12"
    >
      <v-card
        v-if="dadosGrafico"
        class="mx-auto"
        outlined
      >
        <div
          v-if="loading"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <v-card-actions
          v-for="(brinde, index) in dadosGrafico"
          :key="index"
          class="my-4"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      {{ brinde.tipo_operacao }}
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('383')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      md="3"
                      lg="3"
                    >
                      <h4>Total {{ brinde.tipo_operacao }}: {{ getCurrency(brinde.total) }}</h4> <br><br>
                      <canvas
                        :id="'myChartBrinde' + index"
                        class="text-center"
                        width="350"
                        height="180"
                      />
                      <v-row
                        align="center"
                        class="ma-0"
                        no-gutters
                      >
                        <v-col
                          md="12"
                          offset-md="1"
                        >
                          <v-row
                            id="legendaDevolucao"
                          >
                            <div
                              v-for="status in brinde.corExibicao"
                              :key="status.status"
                            >
                              <v-avatar
                                class="mr-1"
                                :color="status.cor"
                                size="12"
                              />
                              <span
                                id="statusDevolucaoPropria"
                                class="mr-3 font-weight-light"
                              >{{ status.status }}</span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="9"
                      md="9"
                      lg="9"
                    >
                      <v-card
                        id="tableBrindePropria"
                      >
                        <div class="d-flex justify-end align-center px-4">
                          <dashboard-export-excel
                            :headers="headers"
                            :table="brinde.dadosTabela"
                            :titulo-relatorio="tituloRelatorio"
                            :texto-grafico="textoGrafico"
                            :tipo-grafico="brinde.tipo_operacao"
                            :enable-btn="false"
                            :data-inicial="dataInicial"
                            :data-final="dataFinal"
                            :empresa-select="empresaSelect"
                            :cidade-select="cidades"
                            :vendedor-select="vendedores"
                            :area-select="areas"
                            :receita="receita"
                            :segmento="segmento"
                            :arquivo="arquivo"
                          />
                        </div>
                        <br>
                        <div
                          id="idTable"
                          style="overflow-x: auto;"
                        >
                          <table
                            style="width: 100%; color: black; border-collapse: collapse;"
                            class="elevation-1"
                          >
                            <thead>
                              <tr>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('nota', index)"
                                >
                                  Núm. da nota
                                  <v-icon small>
                                    {{ sortBy === 'nota' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                  </v-icon>
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('cliente', index)"
                                >
                                  Cliente
                                  <v-icon small>
                                    {{ sortBy === 'cliente' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                  </v-icon>
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('vendedor', index)"
                                >
                                  Vendedor
                                  <v-icon small>
                                    {{ sortBy === 'vendedor' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                  </v-icon>
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('area', index)"
                                >
                                  Área comercial
                                  <v-icon small>
                                    {{ sortBy === 'area' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                  </v-icon>
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('faturamento', index)"
                                >
                                  Valor
                                  <v-icon small>
                                    {{ sortBy === 'faturamento' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                  </v-icon>
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="text-align: center;"
                                  @click="ordenar('motivoBrinde', index)"
                                >
                                  Motivo Brinde
                                  {{ sortBy === 'motivoBrinde' ? (sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item in brinde.dadosTabela"
                              :key="item.id"
                            >
                              <tr>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.nota }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.cliente }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.vendedor }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.area }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right;"
                                >
                                  {{ getCurrency(item.faturamento) }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.motivoBrinde }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-actions><br>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import Chart from 'chart.js'
  import Brinde from '../../../../services/brinde'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardBrinde',
    emits: ['setDadosPrintBrinde'],
    components: {
      DashboardExportExcel: () => import('../../components/core/ExportExcel'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      myChart: {},
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      vendedores: [],
      areas: [],
      receita: [],
      tipoBrinde: [],
      motivoBrinde: [],
      segmento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      loading2: false,
      error2: null,
      headers: [
        { text: 'Núm. da nota', value: 'nota', align: 'left', sortable: true, class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', sortable: true, class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', sortable: true, class: 'black--text title' },
        { text: 'Área comercial', value: 'area', align: 'left', sortable: true, class: 'black--text title' },
        { text: 'Valor', value: 'faturamento', align: 'right', sortable: true, class: 'black--text title' },
        { text: 'Motivo Brinde', value: 'motivoBrinde', align: 'left', sortable: true, class: 'black--text title' },
      ],
      dadosTabelaMotivoBrinde: [],
      texto: null,
      total: '0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      enableTotal: false,
      enableTableBrinde: false,
      enableConsultaBrinde: false,
      corLegenda: [],
      coresGrafico: [],
      exibirLegenda: false,
      codigo: 0,
      orientacao: [],
      textoBrinde: '',
      textoGrafico: 'Brinde',
      dynamicPaddingBrinde: '',
      sortBy: '',
      sortDesc: false,
      dadosGrafico: [],
      tituloRelatorio: 'Relatório Brinde',
      arquivo: 'relatorio_brinde.xlsx',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('disable-consulta', this.disableConsulta)

      eventEmit.$on('update-brinde', this.handleUpdateDados)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)
    },

    beforeDestroy () {
      eventEmit.$off('disable-consulta', this.disableConsulta)

      eventEmit.$off('update-brinde', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBrinde = 'padding-right: 108rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBrinde = 'padding-right: 93rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBrinde = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingBrinde = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingBrinde = 'padding-right: 75rem !important'
        }
      },

      disableConsulta (orientacao) {
        this.orientacao = orientacao

        this.enableConsultaBrinde = false
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, vendedorSelect, areaSelect, tipoBrinde, motivoBrinde, receita, segmento) {
        this.enableConsultaBrinde = true
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.vendedores = vendedorSelect
        this.areas = areaSelect
        this.tipoBrinde = tipoBrinde
        this.motivoBrinde = motivoBrinde
        this.receita = receita
        this.segmento = segmento

        this.atualizaGrafico()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async atualizaGrafico () {
        this.loading = true
        this.enableTotal = false
        this.enableTableDevolucaoPropria = false
        this.exibirLegenda = false

        this.dadosGrafico = []

        if (this.myChart.data) {
          this.texto = false

          this.myChart.destroy()
        }

        await Brinde.showGraficosDadosBrinde(this.dataInicial, this.dataFinal, this.empresaSelect, this.vendedores, this.cidades, this.areas, this.tipoBrinde, this.motivoBrinde, localStorage.tokencontrato, this.receita, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.dadosGrafico = resposta.data.dados

            this.$nextTick(() => {
              this.dadosGrafico.forEach((brinde, index) => {
                this.enableGrafico('myChartBrinde' + index, brinde.dados, brinde.label, brinde.corExibicao, brinde.total)
              })
            })

            eventEmit.$emit('set-dados-print-brinde', this.dadosGrafico)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Não há dados de devolução própria') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.text

            this.total = '0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Não há dados de devolução própria') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.text

            this.total = '0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.msg

            this.total = '0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.text

            this.total = '0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      enableGrafico (nomeGrafico, dados, label, corExibicao, total) {
        const ctx = document.getElementById(nomeGrafico).getContext('2d')

        const cores = []

        for (var i = 0; i < corExibicao.length; i++) {
          const cor = corExibicao[i].cor

          cores.push(cor)
        }

        this.myChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: label,
            datasets: [
              {
                label: 'Faturamento',
                data: dados,
                backgroundColor: cores,
              },
            ],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            cutoutPercentage: 70,
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  var valor = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / 100) * total

                  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' - ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2) + '%'
                },
                title: (tooltipItem) => {
                  if (!label[tooltipItem[0].index]) {
                    return 'NÃO REGISTRADO MOTIVO DE BRINDE'
                  } else {
                    return label[tooltipItem[0].index]
                  }
                },
              },
              titleFontSize: 10,
              bodyFontSize: 10,
            },
          },
        })
      },

      getCurrency (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      mudarOrdenacao (options) {
        this.sortBy = options.sortBy[0]
        this.sortDesc = options.sortDesc[0]

        this.buscarDados(options)
      },

      ordenar (campo, index) {
        if (this.sortBy === campo) {
          this.sortDesc = !this.sortDesc
        } else {
          this.sortBy = campo
          this.sortDesc = false
        }

        this.buscarDados({ sortBy: campo, sortDesc: this.sortDesc, itemsPerPage: this.dadosGrafico[index].dadosTabela.length })
      },

      buscarDados (options) {
        let novaOrdenacao = []
        let index = 0

        for (let i = 0; i < this.dadosGrafico.length; i++) {
          if (this.dadosGrafico[i].dadosTabela.length === options.itemsPerPage) {
            novaOrdenacao = [...this.dadosGrafico[i].dadosTabela]
            index = i
            break
          }
        }

        novaOrdenacao.sort((a, b) => {
          let valA = a[options.sortBy]
          let valB = b[options.sortBy]

          if (options.sortBy === 'faturamento') {
            valA = parseFloat(valA?.toString().replace(/[^\d,-]+/g, '').replace(',', '.')) || 0
            valB = parseFloat(valB?.toString().replace(/[^\d,-]+/g, '').replace(',', '.')) || 0
          }

          let result = 0
          if (valA < valB) result = -1
          if (valA > valB) result = 1
          if (options.sortDesc) result *= -1

          return result
        })

        this.sortBy = options.sortBy
        this.sortDesc = options.sortDesc
        this.dadosGrafico[index].dadosTabela = novaOrdenacao

        eventEmit.$emit('set-dados-print-brinde', this.dadosGrafico)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 90vw !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

  #myChartMaisVida13
    display: grid
    align-items: center
    font-weight: bold
    margin: 4rem 0 0 0
    width: 322px !important
    height: 166px !important

  #totalDevolucaoPropria
    margin: 0 0 0 3rem

  #textTable
    font-size: 0.75rem !important

  #tableBrindePropria
    margin: 0rem 0 0 0

  #statusDevolucaoPropria
    font-size: 0.75rem !important

  #legendaDevolucao
    margin: 2rem 0 0 2rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listIteDevolucoPropria
    margin: -2rem 0 0 -1rem
</style>
